module.exports = __webpack_public_path__ + "static/mspi2-2ccafd70ad170c2450bee4bfab58be92.png";